import { useContext, useEffect, useState } from 'react'
import '../css/document/editnod.css'
import { Dimcontext } from '../../context/pagecontext'
import { Button, Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap'
import { MdClose, MdModeEdit } from 'react-icons/md'
import api from '../../api'
import Swal from 'sweetalert2'
import { Datacontext } from '../../context/dataContext'
import { useNavigate } from 'react-router-dom'
import { auth } from '../../firebase'
import { ToastContainer } from 'react-toastify'

export const Editnod = ({set_edit, id, showToast, docg}) => {
    const { setDim } = useContext(Dimcontext)
    const [doc, setdoc] = useState({})
    const [docname, setdocname] = useState('')
    const { docs } = useContext(Datacontext)
    const navigate = useNavigate()

    const handleeditclose = () => {
        set_edit(false)
        setDim(false)
    }

    

    useEffect(() => { 
        const getedit = async(id) => {
            const d= docs.find(item => item.id === id);
            setdoc(d)
            // Pre-fill the input with the current name for better UX
            setdocname(d.doc_Name)
    }
    getedit(id) }, [id,docs])
    
    const up = async(e) => {
        e.preventDefault()
        const cleanName = docname.trim().toLocaleLowerCase().replace(/\s+/g, ' ')
        
        if (!/^[A-Za-z0-9\s,./\-()]{3,30}$/.test(cleanName)) {
            return showToast("Invalid Format (3-30 chars, no special symbols)");
        }

        try {
            await api.put(`/up_Document/${id}`, { doc_Name: cleanName })
            Swal.fire({
                title: "Updated!",
                text: "Document name changed successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
                timerProgressBar: true 
            });
            handleeditclose()
            docg()
        } catch (err) { console.error(err); 
                    if (err.response && err.response.status === 401) {
                        showToast("Session expired. Attempting to refresh...");
                        try {
                            // Force Firebase to get a fresh token
                            const freshToken = await auth.currentUser.getIdToken(true);
                            sessionStorage.setItem("token", freshToken);
                            // OPTIONAL: Retry the failed request with the freshToken
                            // return retryRequest(originalConfig, freshToken);
                        } catch (refreshErr) {
                            // If refreshing fails, the user session is truly dead
                            showToast("Refresh failed. Logging out.");
                            navigate("/")
                            
                            // window.location.href = '/login'; 
                        }
                    } else {
                        // Handle other types of errors (Network, 500, etc.)
                        showToast("Something went wrong. Please try again.");
                    } }
    }

  return (
    <div className="edit-modal-container1 shadow-lg">
        <ToastContainer/>
        <div className="edit-header">
            <div className="d-flex align-items-center gap-2">
                <MdModeEdit className="text-primary-purple" size={22} />
                <h4 className="m-0 page-title-small">Edit Nature of Document</h4>
            </div>
            <Button onClick={handleeditclose} className='btn-close-custom'><MdClose/></Button>
        </div>
        
        <div className="edit-body p-4">
            <Form onSubmit={up}>
                <FormGroup className="mb-3">
                    <FormLabel className="fw-bold small text-muted text-uppercase">Previous Name</FormLabel>
                    <FormControl 
                        readOnly
                        className="bg-light border-dashed text-muted"
                        value={doc.doc_Name || ''}
                    />
                </FormGroup>

                <FormGroup className="mb-4">
                    <FormLabel className="fw-bold small text-uppercase">New Document Name</FormLabel>
                    <FormControl 
                        required
                        autoFocus
                        value={docname}
                        onChange={(e) => setdocname(e.target.value)}
                        placeholder='Enter new name...'
                        className="custom-input"
                    />
                </FormGroup>

                <div className="d-flex gap-2 justify-content-end border-top pt-3">
                    <Button variant="light" onClick={handleeditclose} className="px-4">Cancel</Button>
                    <Button variant="primary" type='submit' className="px-4 btn-purple">Update Name</Button>
                </div>
            </Form>
        </div>
    </div>
  )
}